import '.by{position:relative;}.ssr-plugin'
import '.a5{width:100%;}.ssr-plugin'
import '.g2{min-height:200px;}.ssr-plugin'
import '.i{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.j{justify-content:center;}.ssr-plugin'
import '.bq{align-items:flex-start;}.ssr-plugin'
import '.s{padding:2rem;}.ssr-plugin'
import '.co{background:var(--shades-white);}.ssr-plugin'
import '.h{overflow:hidden;}.ssr-plugin'
import '.d{position:absolute;}.ssr-plugin'
import '.i8{top:50%;}.ssr-plugin'
import '.i9{right:1rem;}.ssr-plugin'
import '.ia{transform:translateY(-50%);}.ssr-plugin'
import '.ib{width:120px;}.ssr-plugin'
import '.ic{height:120px;}.ssr-plugin'
import '.id{z-index:0;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.hm{z-index:1;}.ssr-plugin'
import '.an{gap:0.5rem;}.ssr-plugin'
import '.ie{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="by a5 g2 i m j bq s co h"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="d i8 i9 ia ib ic id i n j"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="by hm i m bq an ie"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
